import { ControlsBackdrop } from "../../../ui/controls/backdrop.js";
import { ControlsContent } from "../../../ui/controls/content.js";
import { ControlsGroup } from "../../../ui/controls/group.js";
import { ControlsRoot } from "../../../ui/controls/root.js";
import { Value } from "../../../ui/time/value.js";
import { TooltipProvider } from "../../../ui/tooltip/provider.js";
import { ButtonTooltip } from "../shared/components/buttons/button-tooltip.js";
import { AirPlayButton } from "./components/buttons/airplay-button.js";
import { CaptionsButton } from "./components/buttons/captions-button.js";
import { CastButton } from "./components/buttons/cast-button.js";
import { FullscreenButton } from "./components/buttons/fullscreen-button.js";
import { PiPButton } from "./components/buttons/pip-button.js";
import { PlayButton } from "./components/buttons/play-button.js";
import { VolumePopover } from "./components/controls/volume-popover.js";
import { TimeSlider } from "./components/sliders/time-slider.js";
import { VideoSettingsMenu } from "./skins/shared/video/settings-menu.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-video/controls.tsx
/** @jsxImportSource react */
function DefaultVideoControls() {
	return /* @__PURE__ */ jsxs(ControlsRoot, { children: [/* @__PURE__ */ jsx(ControlsBackdrop, { className: "video-controls-backdrop" }), /* @__PURE__ */ jsx(ControlsContent, {
		className: cn("video-controls", "video-controls-content"),
		children: /* @__PURE__ */ jsxs(TooltipProvider, { children: [/* @__PURE__ */ jsxs(ControlsGroup, {
			className: "video-controls-primary",
			children: [
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(PlayButton, {})
				}),
				/* @__PURE__ */ jsx(VolumePopover, { className: "video-controls-volume-button" }),
				/* @__PURE__ */ jsxs(ControlsGroup, {
					className: "video-time-slider-group",
					children: [
						/* @__PURE__ */ jsx(Value, {
							className: cn("media-time-value", "video-time-value"),
							type: "current"
						}),
						/* @__PURE__ */ jsx(TimeSlider, {}),
						/* @__PURE__ */ jsx(Value, {
							className: cn("media-time-toggle", "video-time-value"),
							type: "remaining",
							toggle: true
						})
					]
				}),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(CaptionsButton, { className: "video-controls-captions-button" })
				}),
				/* @__PURE__ */ jsx(VideoSettingsMenu, { className: "video-controls-settings-button" })
			]
		}), /* @__PURE__ */ jsxs(ControlsGroup, {
			className: "video-controls-secondary",
			children: [
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(CastButton, {})
				}),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(AirPlayButton, {})
				}),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(PiPButton, {})
				}),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(FullscreenButton, {})
				})
			]
		})] })
	})] });
}
//#endregion
export { DefaultVideoControls };

//# sourceMappingURL=controls.js.map